/**
 * ActivityFiles.jsx - the files on one activity entry (AL-07): name, size,
 * and Preview / Download.
 *
 * The bytes come through the patched window.fetch (it carries the sign-in
 * token), so this goes through src/utils/attachmentPreview.js with the
 * activity files' own base: /api/crm/attachments/file/<id>.
 */
import { previewAttachment, downloadAttachment } from '../../utils/attachmentPreview';
import { fileSize } from './timelineModel';

/** The activity files' API prefix (routes mounted at /api/crm/activity and /api/crm/attachments). */
export const ACTIVITY_FILES_BASE = '/api/crm';

const LINK_BTN = {
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  fontSize: 10,
  fontWeight: 800,
  color: '#1565C0',
  fontFamily: 'Montserrat',
};

export default function ActivityFiles({ files }) {
  const list = (files || []).filter((f) => f && f.id);
  if (!list.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {list.map((f) => (
        <div key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11, minWidth: 0 }}>
          <span
            style={{ fontWeight: 700, color: '#0D0D0D', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}
            title={f.filename}
          >
            {f.filename || 'File'}
          </span>
          {fileSize(f.size) && <span style={{ color: '#999', fontSize: 10, whiteSpace: 'nowrap' }}>{fileSize(f.size)}</span>}
          <button
            type="button"
            style={LINK_BTN}
            onClick={(e) => {
              e.stopPropagation();
              previewAttachment(f.id, ACTIVITY_FILES_BASE);
            }}
          >
            Preview
          </button>
          <button
            type="button"
            style={LINK_BTN}
            onClick={(e) => {
              e.stopPropagation();
              downloadAttachment(f.id, f.filename, ACTIVITY_FILES_BASE);
            }}
          >
            Download
          </button>
        </div>
      ))}
    </div>
  );
}
